import { render, staticRenderFns } from "./PostTicketPdf.vue?vue&type=template&id=82a412bc&scoped=true&"
import script from "./PostTicketPdf.vue?vue&type=script&lang=js&"
export * from "./PostTicketPdf.vue?vue&type=script&lang=js&"
import style0 from "./PostTicketPdf.vue?vue&type=style&index=0&id=82a412bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a412bc",
  null
  
)

export default component.exports